/*
 * @Author: 吴文洁
 * @Date: 2019-09-16 18:57:44
 * @LastEditors: louzhedong
 * @LastEditTime: 2020-04-10 16:21:08
 * @Description:
 */
export default {
  routes: [
    {
      path: "/archivesShare",
      name: "archives_share",
      component: () => import("@/module/share/ArchivesSharePage.vue"),
      meta: {
        title: "成长档案分享",
        keepAlive: false,
        logined: false
      }
    },
    {
      path: "/comment/share",
      name: "comment_share",
      component: () => import("@/module/share/CommentSharePage.vue"),
      meta: {
        title: "课后点评分享",
        keepAlive: false,
        logined: false
      }
    },
    {
      path: "/homework/share",
      name: "homework_share",
      component: () => import("@/module/share/HomeworkSharePage.vue"),
      meta: {
        title: "学习计划分享",
        keepAlive: false,
        logined: false
      }
    },
    {
      path: "/exam/homework/share",
      name: "exam_homework_share",
      component: () => import("@/module/share/ExamHomeworkSharePage.vue"),
      meta: {
        title: "学习计划分享",
        keepAlive: false,
        logined: false
      }
    },
    {
      path: "/poiuyuttrr",
      name: "transcript_share",
      component: () => import("@/module/transcript/TranscriptDetailPage.vue"),
      meta: {
        title: "成绩单分享",
        keepAlive: false,
        logined: false
      }
    },
    {
      path: "/archives/all/comment",
      name: "archives_all_comment",
      component: () => import("@/module/share/ArchivesAllCommentPage.vue"),
      meta: {
        title: "成长档案全部评论",
        keepAlive: false,
        logined: false
      }
    },
    {
      path: "/comment/all/comment",
      name: "comment_all_comment",
      component: () => import("@/module/share/CommentAllCommentPage.vue"),
      meta: {
        title: "课后点评全部评论",
        keepAlive: false,
        logined: false
      }
    },
    {
      path: "/homework/all/comment",
      name: "homework_all_comment",
      component: () => import("@/module/share/HomeworkAllCommentPage.vue"),
      meta: {
        title: "学习计划全部评论",
        keepAlive: false,
        logined: false
      }
    },
    {
      path: "/archives/inst/share",
      name: "archives_inst_share",
      component: () => import("@/module/share/ArchivesInstSharePage.vue"),
      meta: {
        title: "成长档案分享",
        keepAlive: false,
        logined: false
      }
    },
    {
      path: "/comment/inst/share",
      name: "comment_inst_share",
      component: () => import("@/module/share/CommentInstSharePage.vue"),
      meta: {
        title: "课后点评分享",
        keepAlive: false,
        logined: false
      }
    },
    {
      path: "/homework/inst/share",
      name: "homework_inst_share",
      component: () => import("@/module/share/HomeworkInstSharePage.vue"),
      meta: {
        title: "学习计划分享",
        keepAlive: false,
        logined: false
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/Share.js